import { RefObject, useEffect } from 'react';

interface Input {
    refs: Array<RefObject<HTMLDivElement>>;
    handler: (event: MouseEvent) => void;
}

export function useOnClickOutside({ refs, handler }: Input) {
    useEffect(
        () => {
            const listener = (event: MouseEvent) => {
                // Do nothing if clicking ref's element or descendent elements
                const { target } = event;

                if (
                    target instanceof Node &&
                    refs.some(
                        ({ current }) => current && current.contains(target)
                    )
                ) {
                    return;
                }

                handler(event);
            };

            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);

            return () => {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            };
        },
        // Add ref and handler to effect dependencies
        // It's worth noting that because passed in handler is a new ...
        // ... function on every render that will cause this effect ...
        // ... callback/cleanup to run every render. It's not a big deal ...
        // ... but to optimize you can wrap handler in useCallback before ...
        // ... passing it into this hook.
        [refs, handler]
    );
}

export default useOnClickOutside;
